import { Reducer } from "redux";

import { ServiceStatusReasonActionDispatchTypes } from "../constants/Master";
import { ServiceStatusReasonResponse } from "../models/Api/Master";
import { ServiceStatusReasonDispatchTypes } from "../models/DispatchTypes/Master";
import { setLocalStorageData } from "utils";

export const initialPostState: ServiceStatusReasonResponse = {
  loading: false,
  response: [
    {
      serviceStatusReasonId: -1,
      serviceStatusReason: "",
      captureRequesterName: false,
      isDisabled: true,
    },
  ],
};

const ServiceStatusReasonReducer: Reducer<
  ServiceStatusReasonResponse,
  ServiceStatusReasonDispatchTypes
> = (state = initialPostState, action) => {
  switch (action.type) {
    case ServiceStatusReasonActionDispatchTypes.SERVICE_REASON_STATUS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ServiceStatusReasonActionDispatchTypes.SERVICE_REASON_STATUS_SUCCESS: {
      setLocalStorageData(
        ServiceStatusReasonActionDispatchTypes.SERVICE_REASON_STATUS_SUCCESS,
        action.response
      )
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case ServiceStatusReasonActionDispatchTypes.SERVICE_REASON_STATUS_RESET: {
      return initialPostState;
    }
    case ServiceStatusReasonActionDispatchTypes.SERVICE_REASON_STATUS_ERROR: {
      return initialPostState;
    }
  }
  return state;
};

export default ServiceStatusReasonReducer;
